import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "p-3" }
const _hoisted_4 = { class: "d-flex justify-content-end" }

import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import { useValidateProps } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { DraftImmigrantDto } from "@api/draft-immigrant-dto";
import _, { cloneDeep } from "lodash";
import { PropType, computed, onMounted, ref } from "vue";
import { PersonFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import publicFormApi from "@/publicFormApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImmigrantFormFamilyFields',
  props: {
	fieldsMap: {
		type: Object as PropType<PersonFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftImmigrantDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const fields = dbEnums.PersonFields;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const childDraft = ref(null as DraftImmigrantDto | null);
onMounted(() => {
	publicFormApi.call.personForm.get.getImmigrantDraft().then((r) => {
		if (r.isSuccessful && r.data) {
			childDraft.value = r.data.draftImmigrantData;
		}
	});
});

const addChild = () => {
	if (!formDataComputed.value.children) {
		formDataComputed.value.children = [];
	}
	if (childDraft.value) {
		const newChild = _.cloneDeep(childDraft.value);
		if (formDataComputed.value.municipalitySpotDecisionDate) {
			newChild.municipalitySpotDecisionDate = new Date(
				formDataComputed.value.municipalitySpotDecisionDate
			);
		}
		formDataComputed.value.children.push(newChild);
	}
};

const removeChild = (index: number) => {
	if (formDataComputed.value.children) {
		formDataComputed.value.children?.splice(index, 1);
	}
};

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.sectionHeaders.familyInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.ImmigrantFamily)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.ImmigrantFamily.fields
            }, {
              [_unref(fields).ImmigrantMaritalStatus]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.maritalStatusId"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid }) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.maritalStatus,
                      "onUpdate:valueSingle": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.maritalStatus) = $event)),
                      valueSingleId: formDataComputed.value.maritalStatusId,
                      "onUpdate:valueSingleId": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.maritalStatusId) = $event)),
                      infoTable: "MaritalStatuses",
                      translationsTable: "MaritalStatusTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueSingle", "valueSingleId", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantPartnerInfo]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.partnerInfo"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.partnerInfo,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.partnerInfo) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantChildren]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.children"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formDataComputed.value.children, (child, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "card mb-2",
                        key: i
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(Field, {
                            field: field,
                            propertyPath: `draftImmigrantData.children[${i}].firstName`,
                            label: _ctx.$t('generic.firstName')
                          }, {
                            default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                              _createVNode(_component_HakoInput, {
                                modelValue: child.firstName,
                                "onUpdate:modelValue": ($event: any) => ((child.firstName) = $event),
                                id: elementId,
                                isInvalid: isInvalid,
                                onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                style: {"max-width":"500px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur"])
                            ]),
                            _: 2
                          }, 1032, ["field", "propertyPath", "label"]),
                          _createVNode(Field, {
                            field: field,
                            propertyPath: `draftImmigrantData.children[${i}].lastName`,
                            label: _ctx.$t('generic.lastName')
                          }, {
                            default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                              _createVNode(_component_HakoInput, {
                                modelValue: child.lastName,
                                "onUpdate:modelValue": ($event: any) => ((child.lastName) = $event),
                                id: elementId,
                                isInvalid: isInvalid,
                                onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                style: {"max-width":"500px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur"])
                            ]),
                            _: 2
                          }, 1032, ["field", "propertyPath", "label"]),
                          _createVNode(Field, {
                            field: field,
                            propertyPath: `draftImmigrantData.children[${i}].birthday`,
                            label: _ctx.$t('generic.birthday')
                          }, {
                            default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                              _createVNode(_component_HakoDatePicker, {
                                modelValue: child.birthday,
                                "onUpdate:modelValue": ($event: any) => ((child.birthday) = $event),
                                "allow-empty": "",
                                id: elementId,
                                isInvalid: isInvalid,
                                onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                placeholder: _ctx.$t('generic.datePlaceholder'),
                                style: {"max-width":"250px"},
                                forceUtcMidnight: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                            ]),
                            _: 2
                          }, 1032, ["field", "propertyPath", "label"]),
                          _createVNode(Field, {
                            field: field,
                            propertyPath: `draftImmigrantData.children[${i}].municipalitySpotDecisionDate`,
                            label: _ctx.$t('immigrantForm.municipalitySpotDecisionDate')
                          }, {
                            default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                              _createVNode(_component_HakoDatePicker, {
                                modelValue: child.municipalitySpotDecisionDate,
                                "onUpdate:modelValue": ($event: any) => ((child.municipalitySpotDecisionDate) = $event),
                                "allow-empty": "",
                                id: elementId,
                                isInvalid: isInvalid,
                                onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                placeholder: _ctx.$t('generic.datePlaceholder'),
                                style: {"max-width":"250px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                            ]),
                            _: 2
                          }, 1032, ["field", "propertyPath", "label"]),
                          _createElementVNode("div", _hoisted_4, [
                            (child.id <= 0)
                              ? (_openBlock(), _createBlock(_component_HakoButton, {
                                  key: 0,
                                  theme: "danger",
                                  onClick: () => removeChild(i)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.removeChild")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128)),
                    _createVNode(_component_HakoButton, { onClick: addChild }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.addChild")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantUnderageChildrenExtraInfo]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.underageChildrenExtraInfo"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.underageChildrenExtraInfo,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.underageChildrenExtraInfo) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantFamilyLeaveAndBenefitInfo]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.familyLeaveAndBenefitInfo"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.familyLeaveAndBenefitInfo,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.familyLeaveAndBenefitInfo) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantIsNecessaryToMakeFamilyIntegrationPlan]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.isNecessaryToMakeFamilyIntegrationPlan",
                  "align-content": ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoCheckbox, {
                      modelValue: formDataComputed.value.isNecessaryToMakeFamilyIntegrationPlan,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.isNecessaryToMakeFamilyIntegrationPlan) = $event)),
                      for: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "for", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantFamilyIntegrationPlanDetails]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.familyIntegrationPlanDetails"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.familyIntegrationPlanDetails,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.familyIntegrationPlanDetails) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantSocialNetworks]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.socialNetworks"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.socialNetworks,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.socialNetworks) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantHobbiesOrOrganizationalActivities]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.hobbiesOrOrganizationalActivities"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.hobbiesOrOrganizationalActivities,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.hobbiesOrOrganizationalActivities) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantHasBeenGivenGuidanceForSocialOrOrganizationServices]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.hasBeenGivenGuidanceForSocialOrOrganizationServices",
                  "align-content": ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoCheckbox, {
                      modelValue: formDataComputed.value.hasBeenGivenGuidanceForSocialOrOrganizationServices,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.hasBeenGivenGuidanceForSocialOrOrganizationServices) = $event)),
                      for: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "for", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantGuidanceGuidanceExtraInfo]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.guidanceExtraInfo"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.guidanceExtraInfo,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.guidanceExtraInfo) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})